
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexthPO2MAAweMeta } from "/home/runner/work/cv/cv/pages/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/runner/work/cv/cv/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/home/runner/work/cv/cv/pages/index.vue")
  }
]